var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.black { fill: #171717; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "black",
    d: "M341.7,44.2H166.8c-68.5,0-124.3,55.9-124.3,124.3v174.8c0,68.5,55.9,124.3,126.1,124.3h174.8 c68.5,0,124.3-55.9,126.1-124.3V168.5C467.8,100.1,410.1,44.2,341.7,44.2z M426.4,168.5v174.8c0,46.9-37.8,82.9-82.9,82.9H168.6 c-46.9,0-82.9-37.8-84.7-82.9v-173c0-46.9,37.8-82.9,84.7-84.7h174.8C388.5,85.6,426.4,123.5,426.4,168.5z M255.1,137.9L255.1,137.9 c-64.9,0-118.9,52.3-118.9,118.9s52.3,118.9,118.9,118.9c64.9,0,118.9-52.3,118.9-118.9C372.3,192,320,137.9,255.1,137.9z  M255.1,181.2c41.4,0,75.7,34.2,75.7,75.7s-34.2,75.7-75.7,75.7s-75.7-34.2-75.7-75.7C179.5,215.4,213.7,181.2,255.1,181.2z  M372.3,127.1c11.9,0,21.6,9.7,21.6,21.6s-9.7,21.6-21.6,21.6c-11.9,0-21.6-9.7-21.6-21.6S360.3,127.1,372.3,127.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.97af2a3c.svg";
export { ForwardRef as ReactComponent };